export default "__VITE_ASSET__DOw1h_D$__"